import * as React from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router';
import { InquiryModes } from 'src/Library/Constants'
import { connect } from 'react-redux';
import { useGenericState } from 'src/Library/UseGenericState';
import { StylesProps , KeyLabel } from 'src/Library/Types';
import { bindActionCreators } from 'redux';
import { sendBulkInquiry } from 'src/api/inquiry';
import { SendBulkInquiryStyles } from './SendBulkInquiry.styles';
import { getFFDimensions } from 'src/selectors/importsFilter';
import { Button, message, Drawer, Icon, Tooltip} from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { isValidArray } from 'src/Library/Helper';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Select from 'antd/lib/select';
import Checkbox from 'antd/lib/checkbox';
import { fetchLinkedFFs, fetchOrganisationFFGroups } from 'src/api/masters';
import { fetchStrategicVendorList } from 'src/Library/Common';
import { arrayToObject } from 'src/utils/utils';
import { FFType } from '../../DiscoverRate/DiscoverRateUtils';
import Spin from 'antd/lib/spin';
import { getAllInquiriesApplyFilter } from 'src/actions/inquiryShipperActions';
import DisplaySelectedInquiries from './DisplaySelectedInquiries';
import { tokens } from 'src/design-system';

interface IProps extends StylesProps<ReturnType<typeof SendBulkInquiryStyles>>, FormComponentProps {
  isVisible: boolean;
  milestonesLoading: boolean;
  onClose: (params: any) => void;
  selectedItems : Record<string, any>;
  onSubmit: () => void;
  getAllInquiriesApplyFilter;
  showDiscoverBuyRates;
  hideStrategicVendors;
}

interface StateProps {
  isLoading?: boolean;
  fetchingFFs: boolean;
  strategicFFs?: any[];
  fetchedFFs?: any[];
  mapFetchedFFs?: any;
  showRows?: boolean;
  sentFfIds?: any[];
  checkedList?: any[];
  selectedStrategicFFs?: any;
  isAllStrategicFFsSelected: boolean;
  selectAll: boolean;
  groupVendorsMap: Record<string, Array<{ id: string; name: string }>>;
}

const SendBulkInquiryModal = (props: IProps) => {

  const [state, setState] = useGenericState<StateProps>({
    isLoading: false,
    fetchingFFs: false,
    showRows: false,
    fetchedFFs: [],
    strategicFFs: [],
    mapFetchedFFs: [],
    sentFfIds: [],
    checkedList: [],
    selectedStrategicFFs: [],
    isAllStrategicFFsSelected: false,
    selectAll: false,
    groupVendorsMap: {},
  });

  const {
    isLoading,
    fetchingFFs,
    showRows,
    fetchedFFs,
    strategicFFs,
    mapFetchedFFs,
    checkedList,
    selectedStrategicFFs,
    sentFfIds,
    isAllStrategicFFsSelected,
    selectAll,
    groupVendorsMap,
  } = state;

  const {
    classes,
    isVisible,
    onClose,
    selectedItems,
    showDiscoverBuyRates,
    hideStrategicVendors,
    onSubmit,
  } = props;

  const isDisabled: boolean = (selectedStrategicFFs?.length > 0 || (checkedList?.length && checkedList.length > 0)) ? false : true;
  let inquiryMode : string|undefined;
  
  React.useEffect(()=>{
    fetchData();
  },[])

  const fetchData = async () =>{
    setState({fetchingFFs: true})
    inquiryMode = getInquiryMode();

    const responses = await Promise.all([
      fetchLinkedFFs({
        organisationType: 'FF',
        mode: (inquiryMode === 'AIRCARGO' ? 'AIR' : inquiryMode),
      }),
      fetchOrganisationFFGroups({}),
    ]);
    let fetchedFFs: any[] = [];
    const nextGroupVendorsMap: Record<string, Array<{ id: string; name: string }>> = {};
    responses.forEach((response: any, index) => {
      if (!response.isSuccess) {
        message.error(response.errorMessage);
      }
      const isGroupResponse = index !== 0;
      const formatResponse = response.data ? response.data.map((item) => {
        if (!isGroupResponse && isValidArray(item?.groupIds)) {
          item.groupIds.forEach((groupId: string) => {
            if (!groupId) return;
            if (!nextGroupVendorsMap[groupId]) nextGroupVendorsMap[groupId] = [];
            nextGroupVendorsMap[groupId].push({ id: item.id, name: item.name });
          });
        }
        return {
          key: item.id,
          label: item.name,
          isGroup: isGroupResponse,
        };
      }) : [];
      fetchedFFs = [...fetchedFFs, ...formatResponse];
    });
    setState({sentFfIds : getSentFFIds()})

    const ffList = fetchedFFs?.map(item => item.key) || [];
    const strategicFFs = showDiscoverBuyRates && !hideStrategicVendors ? await fetchStrategicVendorList(ffList, [], inquiryMode) : [];
    setState({
      strategicFFs,
      fetchedFFs,
      fetchingFFs: false,
      mapFetchedFFs: arrayToObject(fetchedFFs, 'key'),
      groupVendorsMap: nextGroupVendorsMap,
    });
  }

  const getSentFFIds = () => {
    let sentFfIds : any[] = [];
    Object.values(selectedItems).forEach((inquiry) => {
      sentFfIds = Array.from(new Set([...sentFfIds, ...inquiry.sentFfIds]));
      sentFfIds.push(inquiry?.sentFfId);
    })

    return sentFfIds;
  }

  const getInquiryMode = () => {
    let mode : string | undefined;
    let areInquiriesValid = true;
    Object.values(selectedItems).forEach((inquiry) => {
      if (!mode){
        mode = inquiry?.mode;
      } else {
        if (mode !== inquiry?.mode){
          areInquiriesValid = false;
        }
      }
    })
    if (areInquiriesValid)
      return mode;
    else
      return undefined;
  }

  const getCheckedFFs = (isGroup) => {
    return checkedList?.filter((ff: any) => {
      return mapFetchedFFs[ff.key].isGroup === isGroup;
    }).map((ff: any) => {
      return ff.key;
    });
  }

  const handleSubmit = async() =>{
    setState({
      isLoading: true,
    });
    const ffIds = getCheckedFFs(false);
    const ffGroupIds = getCheckedFFs(true);
    const strategicFFs = selectedStrategicFFs?.map((item: KeyLabel) => item.key);

    const params = {
      strategicFFs, 
      inquiryIdList: Object.keys(selectedItems).map((key) => key),
      ...(ffIds?.length && {
        ffIds,
      }),
      ...(ffGroupIds?.length && {
        ffGroupIds,
      }),
    };
    const response = await sendBulkInquiry(params);
    setState({
      isLoading: false,
    });
    if (response.isSuccess) {
      message.success('Inquiry sent successfully');
    } else {
      message.error('Send Inquiry failed for selected inquiries. Please try again.')
    }
    onSubmit();
    onClose({});
  }

  const renderTitle = () => {
    return (
      <div className={classes.modalHeader}>
        <div>
        <Icon type="close" className={classes.closeIcon} onClick={() => onClose({})} />
        <span className={classes.modalTitle}>Send Inquiry</span>
        </div>
        <Button
          className={isDisabled ? classes.submitButtonDisabled : classes.submitButton}
          onClick={() => {
            if (isDisabled) return;
            handleSubmit()
          }}
          loading={isLoading}
        >
          Send
        </Button>
      </div>
    )
  }

  const getValueFromKeyMap = (type: string, option: string) => {

    let keyMap;
    if (type === FFType.STRATEGIC_FF) {
      keyMap = {
        selectedFFList: selectedStrategicFFs,
        selectedFFListKey: 'selectedStrategicFFs',
        ffList: strategicFFs,
        selectAllKey: 'isAllStrategicFFsSelected',
        isSelectAll: isAllStrategicFFsSelected,
      }
    } else {
      keyMap = {
        selectedFFList: checkedList,
        selectedFFListKey: 'checkedList',
        ffList: fetchedFFs,
        selectAllKey: 'selectAll',
        isSelectAll: selectAll,
      }
    }
    return keyMap[option];
  }

  const getVendorLabel = () => {
    let vendorLabel : string | undefined;
    let isValidVendorLabel = true;
    Object.values(selectedItems).forEach((inquiry) : any=> {
      const label = inquiry.mode === InquiryModes.TRAILER || inquiry.mode === InquiryModes.DOMESTIC ? 'Trucking Agents' : 'Forwarders';
      if (!vendorLabel){
        vendorLabel = label;
      } else {
        if (vendorLabel !== label){
          isValidVendorLabel = false;
        }
      }
    })
    if (isValidVendorLabel)
      return vendorLabel;
    else
      return undefined;
  }

  const isSelectAllDisabled = (type) => {
    const ffList = getValueFromKeyMap(type, 'ffList');
    return ffList?.some((item : KeyLabel) => sentFfIds?.indexOf(item.key) !== -1);
  }

  const  isSelectAllChecked = (type) => {
    const selectedFFList = getValueFromKeyMap(type, 'selectedFFList');
    const ffList = getValueFromKeyMap(type, 'ffList');
    const isSelectAll =getValueFromKeyMap(type, 'isSelectAll');
    return selectedFFList?.length === ffList?.length || isSelectAll;
  }

  const renderSelectFFsOptions = () => {
    return (
      strategicFFs?.map((ff : KeyLabel) => (
        <Select.Option
          style={{ display: 'flex' }}
          key={ff.key}
          value={ff.label}
          disabled={sentFfIds?.indexOf(ff.key) !== -1}
        >
          <Checkbox
            key={ff.key}
            checked={selectedStrategicFFs?.some((item: KeyLabel) => item.key === ff.key)
              || isAllStrategicFFsSelected || sentFfIds?.indexOf(ff.key) !== -1}
            disabled={sentFfIds?.indexOf(ff.key) !== -1} />
          <span className={classes.optionsDiv}>
            {ff.label}
            <span className={classes.sentBidStyle}>
              {sentFfIds?.indexOf(ff.key) !== -1 ? 'Sent' : ''}
            </span>
          </span>
        </Select.Option>
      ))
    )
  }
  
  const   generateOptions = () => {
    const ffSentMap = new Map();
    const selectedFfs: any = new Set(checkedList?.map(check => check.key));
    sentFfIds?.forEach(ff => ffSentMap.set(ff, 1));
    const vendorLabel = inquiryMode === InquiryModes.TRAILER || inquiryMode === InquiryModes.DOMESTIC ? 'Trucker' : 'FF';
    const options = fetchedFFs?.map((item: any) => {
      return (
        <Select.Option key={item.key}
          disabled={ffSentMap.has(item.key)}
          value={item.label}>
          <div style={{ display: 'flex' }}>
            <Checkbox checked={selectedFfs.has(item.key) || ffSentMap.has(item.key) ? true : false}
              disabled={ffSentMap.has(item.key) ? true : false}>
            </Checkbox>
            <div className={classes.optionsDiv}><span 
                style={{
                  width: '220px',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap'
                }}>{item.label}</span>
              <div>
                <span className={classes.sentBidStyle}>
                  {ffSentMap.has(item.key) ? 'Sent' : ''}
                </span>
                <span className={item.isGroup ? classes.groupType : classes.ffType}>
                  {item.isGroup ? 'Group' : vendorLabel}</span>
              </div></div>
          </div>
        </Select.Option>
      )})
    return options;
  }

  const updateRows = (element, type) => {
    const selectedFFList = getValueFromKeyMap(type, 'selectedFFList');
    const selectedFFListKey = getValueFromKeyMap(type, 'selectedFFListKey');
    setState(
      {
        [selectedFFListKey]: selectedFFList?.filter((elem: any) => elem.key !== element),
      },
    );
  }

  const renderGroupVendors = (groupId: string) => {
    const vendors = groupVendorsMap?.[groupId] || [];
    if (!isValidArray(vendors)) {
      return <div className={classes.groupEmpty}>No vendors linked</div>;
    }
    return (
      <div className={classes.groupVendorsList}>
        {vendors.map((vendor) => (
          <span key={vendor.id} className={classes.groupVendorTag}>{vendor.name}</span>
        ))}
      </div>
    );
  }

  const renderRow = (type) => {
    const ffList = getValueFromKeyMap(type, 'selectedFFList');
    const checks = ffList?.map((element) => {
      const ffMeta = type === FFType.MY_FF ? mapFetchedFFs?.[element.key] : undefined;
      const isGroup = !!ffMeta?.isGroup;
      return (
        <div className={classes.selectedRowContainer} key={element.key}>
          <Row>
            <Col span={22}>
              <h5 style={{
                fontSize: `${tokens.fontSize.small}px`, color: '#1990FF', marginTop:
                  '4px', paddingLeft: '4px',
                display: 'flex', alignItems: 'center',
              }}>
                {element.value}
                {isGroup && <span className={classes.groupType}>Group</span>}
              </h5>
            </Col>
            <Col span={1}>
              <div
                onClick={() => updateRows(element.key, type)}>
                <Icon style={{
                  width: '9.33px', height: '9.33px', color: '#EC4522',
                  marginTop: '12px', cursor: 'pointer',
                }} type="close" />
              </div>
            </Col>
          </Row>
          {isGroup && renderGroupVendors(element.key)}
        </div>
      );
    });
    return checks;
  }

  const handleChange = (options, type) => {
    const ffList = getValueFromKeyMap(type, 'ffList') || [];
    const selectedFFList = getValueFromKeyMap(type, 'selectedFFList') || [];
    const selectAllKey = getValueFromKeyMap(type, 'selectAllKey');
    const isSelectAll = getValueFromKeyMap(type, 'isSelectAll');
    const selectedFFListKey = getValueFromKeyMap(type, 'selectedFFListKey');
    if (options[0].key === 'all') {
      setState({
        [selectAllKey]: !isSelectAll,
        [selectedFFListKey]: !isSelectAll ?
          ffList.map((ff: KeyLabel) => ({ key: ff.key, value: ff.label })) : [],
      });
    } else {
      const findRes = selectedFFList?.find(
        filter => filter.key === options[0].key);
      findRes ?
        setState({
          [selectAllKey]: false,
          [selectedFFListKey]:
            selectedFFList?.filter(fil => fil.key !== options[0].key),
        })
        : setState({
          [selectedFFListKey]: [...selectedFFList,
            {
              key: options[0].key,
              value: options[0].props.value,
            },
          ],
        },
          () => {
            selectedFFList?.length === ffList?.length ?
              setState({ [selectAllKey]: true }) :
              setState({ [selectAllKey]: false });
          },
        );
    }
  }
  const renderSelect = (type) => {
    const vendorLabel = getVendorLabel();
    return <Row style={{ width: '100%' }}>
    <Col span={25}>
      <div style={{ width: '100%' }}>
        <Select
          mode="multiple"
          disabled={fetchingFFs}
          className={classes.multiselect}
          placeholder={`Search & Select ${vendorLabel}`}
          dropdownClassName={classes.multiselect}
          showSearch={true}
          showArrow
          value={[]}
          autoClearSearchValue={false}
          style={{ width: '100%' }}
          onDropdownVisibleChange={open => !open ? setState({ showRows: true }) :
            setState({ showRows: false })}
          onChange={(filtervals, options) => { handleChange(options, type);  }
          }
        >
          <Select.Option key="all" value="all"
            disabled={isSelectAllDisabled(type)}>
              <Checkbox
                checked={isSelectAllChecked(type)}
                key="all"
                disabled={isSelectAllDisabled(type)}
              />
              <div style={{ display: 'inline-block', marginLeft: 12 }}>Select All</div>
          </Select.Option>
          {type === FFType.STRATEGIC_FF ? renderSelectFFsOptions() : generateOptions()}
        </Select>
      </div>
      <div className={classes.ffList}>{renderRow(type)}</div>
    </Col>
  </Row>;
  }

  const renderMyFfs = () => {
    return (
      <div className={classes.FfsPanel}>
        <div className={classes.selectedFFsPanel} > <span>My {getVendorLabel()}</span></div>
        <div style = {{width:'100%', borderBottom: '1px solid #cccccc', paddingBottom: '10px'}}> {renderSelect(FFType.MY_FF)} </div>
      </div>
    )
  }

  const renderStrategicFfs = () => {
    return (
      <div className={classes.FfsPanel}>
        <div className={classes.selectedFFsPanel} > <span>Shipsy's {getVendorLabel()}</span></div>
        <div style = {{width:'100%'}}> {renderSelect(FFType.STRATEGIC_FF)} </div>
      </div>
    )
  }

  const renderFFSelection = () : React.ReactElement => {
    return (
      <div style = {{width: '100%', borderBottom: '1px solid #cccccc'}}>
        {renderMyFfs()}
        {showDiscoverBuyRates && !hideStrategicVendors && fetchingFFs && !isValidArray(strategicFFs) && <Spin style={{ width:'100%' , justifyContent: 'center', alignItems: 'center', margin: '10px'}} />}
        {(isValidArray(strategicFFs) && showDiscoverBuyRates && !hideStrategicVendors && (inquiryMode !== InquiryModes.DOMESTIC)) && renderStrategicFfs()}
      </div>
    )

  }

  const renderInquiryDetails = () => {
    return (
      <div>
        {renderFFSelection()}
        <DisplaySelectedInquiries/>
      </div>
    )
  }

  return (
    <Drawer
    visible={isVisible}
    closable={false}
    onClose={() => onClose({})} 
    className={classes.drawer}
    title={renderTitle()}
    >
      {renderInquiryDetails()}
      
  </Drawer>
  );
};

const mapStateToProps = ({masterData, inquiryShipperReducer}) => ({
  ffList: getFFDimensions(masterData),
  selectedItems : inquiryShipperReducer.selectedItems || {},
  showDiscoverBuyRates: masterData.modules.show_discover_buy_rates,
  hideStrategicVendors: masterData.modules.hide_strategic_vendors,
});
const mapDispatchToProps = dispatch => (bindActionCreators({
  getAllInquiriesApplyFilter,
}, dispatch));

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectSheet(SendBulkInquiryStyles)(SendBulkInquiryModal)));
